import { Provider } from "react-redux";
import "./App.css";
import { store } from "./store/index";
import RoutersNew from "./routersnew";
import "./App.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";

function App() {
  const [language, setLanguage] = useState("en");

  const handleLanguageChange = (language) => {
    setLanguage(language);
    const googleTranslateElement = document.querySelector(".goog-te-combo");
    // console.log("t123", language, googleTranslateElement);
    if (googleTranslateElement) {
      googleTranslateElement.value = language;
      googleTranslateElement.dispatchEvent(new Event("change"));
    }
  };

  useEffect(() => {
    window.loadGoogleTranslate();
  }, [language]);

  return (
    <Provider store={store}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />
      <RoutersNew
        language={language}
        setLanguage={setLanguage}
        handleLanguageChange={handleLanguageChange}
      />
    </Provider>
  );
}

export default App;
